import { WhyUsHero } from '../components/sections/WhyUsHero';
import { WhyUsDifferentiators } from '../components/sections/WhyUsDifferentiators';
import { WhyUsD2D } from '../components/sections/WhyUsD2D';
import { WhyUsClients } from '../components/sections/WhyUsClients';
import { WhyUsPartners } from '../components/sections/WhyUsPartners';
import { WhyUsCTA } from '../components/sections/WhyUsCTA';

const WhyUs = () => (
  <div>
    <WhyUsHero />
    <WhyUsDifferentiators />
    <WhyUsD2D />
    <WhyUsClients />
    <WhyUsPartners />
    <WhyUsCTA />
  </div>
);

export default WhyUs;
